module.exports = {
  header: {
    Learnmore:'Learn more',
    Email:'E-mail',
    Telno:'Tel no',
    Contact:'Contact',
    XiAn:"Xi'an",
    HongKong:"Hong Kong",
    Shanghai:'Shanghai',
    banq:'Copyright © 2021 Champion Aviation Dynamic Technology (China) Co., Ltd, All rights reserved.',
    Name:'Name',
    Email1:'Email',
    Phone:'Phone',
    Remark:'Remark',
    Learn:'Learn More >',
    Details:'Details',
    close:'Close',
    send:'Send',
  },
}



// WEBPACK FOOTER //
// ./src/lang/en.js